module.exports = __webpack_public_path__ + "img/Xgrow-6-es.8f2773fd.png";